module.exports = __webpack_public_path__ + "static/media/insitu_tem_wor.2e3b6be6.png";